const supplierEndpoints = {
  accounting: () => '/reporting/suppliers/accounting'
}

export default supplierEndpoints
